<template>
  <v-dialog
    v-model="alwaysOpen"
    :fullscreen="isMobile"
    width="80%"
    max-width="512px"
    @click:outside="close"
  >
  <v-card class="form-dialog form-dialog--payout-id">
      <v-icon
      class="form-dialog__button form-dialog__button--close"
      @click="close"
      >
      mdi-close
      </v-icon>

      <h1 class="form-dialog__title">
        {{ $t('form_add_restrictions_title', { product_name: 'Vistor parking'}) }}
      </h1>

      <span
        class="form-dialog__subtitle"
      >
        {{ $t('form_add_restrictions_message', { product_name: 'Vistor parking'}) }}
      </span>
      <v-form ref="weekdayForm" class="mt-3 weekly-price-form">
      <v-row class="form-row input-row">
      <v-col cols="6">
            <div class="text-input-label">{{ $t('from') }}</div>
            <v-text-field
            class="form-font font-weight-bold"
            v-model="formData.time_of_day_start"
            solo
            flat
            dense
            background-color="#F6F6F6"
            :rules="[rules.isValidTime]"
            :disabled="disableField"
            />
      </v-col>

      <v-col cols="6">
            <div class="text-input-label">{{ $t('until') }}</div>
            <v-text-field
            class="form-font font-weight-bold"
            v-model="formData.time_of_day_end"
            solo
            flat
            dense
            background-color="#F6F6F6"
            :rules="[rules.isValidTime]"
            :disabled="disableField"
            />
      </v-col>
      </v-row>

      <v-row class="form-row input-row">
      <v-col>
            <div class="text-input-label">
              {{ $t('form_add_restrictions_message') }}
            </div>

            <v-chip-group
            v-model="weekdaySelection"
            outlined
            multiple
            class="week-price-chip-group"
            active-class="v-chip--active"
            :disabled="disableField"
            >
            <v-chip
            class="v-chip"
            v-for="(item, i) in weekday"
            :disabled="disableField"
            :key="i"
            >
            {{ item }}
            </v-chip>
            </v-chip-group>
      </v-col>
      </v-row>
      <v-row class="input-row">
            <v-col cols="6">
              <div class="text-input-label">Valid from</div>
              <v-menu
                v-model="menuVisibleValidFrom"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
                :disabled="disableField"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="form-font"
                    v-model="visibleValidFrom"
                    readonly
                    solo
                    flat
                    dense
                    background-color="#F6F6F6"
                    v-on="on"
                    :disabled="disableField"
                  >
                    <template v-slot:append>
                      <div @click="handleIconValidFromClick" class="clickable">
                        <img :src="dropdownNarrow" />
                      </div>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  no-title
                  color="primary"
                  v-model="visibleValidFromDate"
                  @input="menuVisibleValidFrom = false"
                  :disabled="disableField"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <div class="text-input-label">Valid till</div>
              <v-menu
                v-model="menuVisibleValidUntil"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                class="menu-style"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="form-font"
                    v-model="visibleValidUntil"
                    readonly
                    solo
                    v-on="on"
                    flat
                    dense
                    background-color="#F6F6F6"
                  >
                    <template v-slot:append>
                      <div
                        @click="handleIconValidUntilClick"
                        class="clickable"
                      >
                        <img :src="dropdownNarrow" />
                      </div>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-if="menuVisibleValidUntil"
                  v-model="visibleValidUntilDate"
                  color="primary"
                  no-title
                  @input="menuVisibleValidUntil = false"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
      <v-row class="form-dialog__button-wrap">
      <v-col cols="12">
            <v-btn
            class="pkmn-button pkmn-button--has-border"
            color="primary"
            @click="addAllowedTime"
            :disabled="!disableButton"
            >
            Confirm
            </v-btn>
      </v-col>
      </v-row>
      </v-form>
</v-card>
</v-dialog>

</template>

<script>
import dropdownNarrow from '@/assets/dropdown_arrow.svg'
import moment from 'moment'
import rules from '@/helpers/validation'
import { mapGetters } from 'vuex'

export default {
  name: 'FormAddRestrictions',
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      alwaysOpen: true,
      formData: {
        ids: null,
        time_of_day_start: '00:00:00',
        time_of_day_end: '00:00:00',
        weekday: [],
        valid_from: null,
        valid_to: null
      },
      dialog: false,
      dialogDelete: false,
      weekday: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
      weekdaySelection: [],
      mobileBreakpoint: 767, // screen width in pixel to switch to mobile view
      dropdownNarrow,
      menuVisibleFromTime: false,
      menuVisibleUntilTime: false,
      rules: rules,
      visibleValidFrom: '',
      menuVisibleValidFrom: false,
      visibleValidFromDate: null,
      visibleValidUntil: '',
      menuVisibleValidUntil: false,
      visibleValidUntilDate: null,
    }
  },

  watch: {
    data(newValue) {
      if (newValue) {
        this.formData.time_of_day_start = newValue.time_of_day_start
      }
    },
    visibleValidFromDate(newValue) {
      if (newValue) {
        const date = moment(newValue)
        this.visibleValidFrom = date.format('DD.MM.YYYY')
        this.formData.valid_from = moment.utc(date, 'DD.MM.YYYY').unix()
      }
    },
    visibleValidUntilDate(newValue) {
      if (newValue) {
        const date = moment(newValue)
        this.visibleValidUntil = date.format('DD.MM.YYYY')
        this.formData.valid_to = moment.utc(date, 'DD.MM.YYYY').unix()
      }
    },
    weekdaySelection(newValue) {
      if (newValue) {
        this.formData.weekday = newValue.map(day => day + 1);
      }
    }
  },

  computed: {
    ...mapGetters(['timeUnitOptions', 'currentProductCurrencySymbol']),
    isMobile() {
      return window.innerWidth <= this.mobileBreakpoint
    },
    disableField() {
      return (this.data !== null)
    },
    disableButton() {
      return this.formData.time_of_day_start !== this.formData.time_of_day_end && this.formData.weekday.length > 0 && this.formData.valid_from !== null
    }
  },

  methods: {
    toHHmmss(timeStr) {
      if (!timeStr) return timeStr
      const parts = String(timeStr).split(':')
      const h = (parts[0] || '00').padStart(2, '0')
      const m = (parts[1] || '00').padStart(2, '0')
      const s = (parts[2] || '00').padStart(2, '0')
      return `${h}:${m}:${s}`
    },
    addAllowedTime() {
      if (this.$refs.weekdayForm.validate()) {
        const data = {
          ...this.formData,
          time_of_day_start: this.toHHmmss(this.formData.time_of_day_start),
          time_of_day_end: this.toHHmmss(this.formData.time_of_day_end)
        }
        this.$emit('submit', data)
      }
    },
    close() {
      this.$emit('close')
    },
    handleIconValidFromClick() {
      // Open the menu when the icon is clicked
      this.menuVisibleValidFrom = !this.menuVisibleValidFrom
    },
    handleIconValidUntilClick() {
      // Open the menu when the icon is clicked
      this.menuVisibleValidUntil = !this.menuVisibleValidUntil
    }
  },
  mounted() {
    if (this.data) {
      this.formData.ids = this.data.ids
      this.formData.time_of_day_start = this.data.time_of_day_start || '00:00:00'
      this.formData.time_of_day_end = this.data.time_of_day_end || '00:00:00'
      this.weekdaySelection = this.data.days.map(day => day - 1)
      if (this.data.valid_from) {
        const validFromDate = moment.unix(this.data.valid_from)
        this.visibleValidFromDate = validFromDate.format('YYYY-MM-DD')
      }

      if (this.data.valid_to) {
        const validToDate = moment.unix(this.data.valid_to)
        this.visibleValidUntilDate = validToDate.format('YYYY-MM-DD')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/common';

.v-data-table__title {
  @include text-body;
  font-weight: 700;
  color: $text-color-dark;
}

.form-row {
  min-height: 60px;
  max-height: 70px;
}

.pkmn-button--delete {
  color: $color-white;
}

.schedule-table {
  background-color: $color-alt-background !important;
}

.table-weekday {
  width: 770px;
}

.together {
  padding-bottom: 0px;
}

.text-input-label {
  &__without-text {
    height: 12px;
  }
}
</style>
<style lang="scss">
.week-price-chip-group {
  .v-slide-group__content {
    padding-top: 0;
    justify-content: space-between;
  }
}
.weekly-price-form,
.weekly-price-form-delete {
  .font-weight-bold input,
  .font-weight-bold .v-select__selection {
    font-weight: 900;
    line-height: 20px;
  }
  .input-mr {
    margin-right: 12px;
  }
  .form-dialog__button-wrap {
    margin-top: 36px !important;
  }
}
</style>
